import { createSelector } from "reselect";
import { startsWith, cloneDeep } from "lodash";
import { itemmap } from "./model";

export const getIsFetchingItemmap = (state, props) =>
  state.itemmap.params.isFetching;
export const getIsItemmapFetched = (state, props) =>
  state.itemmap.params.itemmapFetched;
export const getItemmapList = (state, prop) => state.itemmap.byId;
export const getIsSearching = (state, props) =>
  state.itemmap.params.isSearching;
export const getIsSearchFetched = (state, props) =>
  state.itemmap.params.searchFetched;
export const getSearchResults = (state, prop) => state.itemmap.searchResults;
export const filters = (state, prop) => state.itemmap.filterResults;
export const getDeleteStatus = (state, prop) => state.itemmap.deleteStatus;
export const getDelFetched = (state, prop) => state.itemmap.params.isDelFetched;
export const getNotification = (state, id) => state.itemmap.notifications[id];

export const itemmapSelector = (state, prop) => state.itemmap.byId;

export const getItemmap = (state, props) => {
  if (props.match.path === "/itemmap/create") {
    return itemmap();
  }
  if (props.match.path === "/itemmap/edit/:id") {
    let id = props.match.params.id;
    let obj = cloneDeep(state.itemmap.byId[id]);
    obj.cid = parseInt(obj.cid, 10)
    obj.segid = parseInt(obj.segid, 10)
    return obj;
  }
  if (props.match.path === "/itemmap/clone/:id") {
    let id = props.match.params.id;
    let obj = cloneDeep(state.itemmap.byId[id]);
    obj.cid = parseInt(obj.cid, 10)
    obj.segid = parseInt(obj.segid, 10)
    return obj;
  }
};

export const getItemmapParams = (state, props) => {
  const params = {};

  if (startsWith(state.router.location.pathname, "/itemmap/create")) {
    params.title = state.itemmap.params.createTitle;
    params.submitButtonText = state.itemmap.params.createSubmitButtonText;
  }

  if (startsWith(state.router.location.pathname, "/itemmap/edit/")) {
    params.title = state.itemmap.params.editTitle;
    params.submitButtonText = state.itemmap.params.editSubmitButtonText;
  }

  if (startsWith(state.router.location.pathname, "/itemmap/clone/")) {
    params.title = state.itemmap.params.cloneTitle;
    params.submitButtonText = state.itemmap.params.cloneSubmitButtonText;
  }

  return params;
};

export const selectItemmap = createSelector(getItemmapList, (itemmap) => {
  const keys = Object.keys(itemmap);
  const obj = keys.map((key) => {
    return { key: key, value: key, text: itemmap[key].name };
  });
  return obj;
});

export const selectItemmapSearched = createSelector(
  getSearchResults,
  (itemmap) => {
    const keys = Object.keys(itemmap);
    const obj = keys.map((key) => {
      return { key: key, value: key, text: itemmap[key].name };
    });
    return obj;
  },
);

export const getFilteredItemmap = createSelector(itemmapSelector, (itemmap) => {
  let filteredItemmap = Object.keys(itemmap).map(function (key) {
    return itemmap[key];
  });
  return filteredItemmap;
});
